module.exports = "/9/0-kieu-liet-ke-enum/index.html.5bcab9708527435f7e4986ca2293f162.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/32760.md
 ** module id = 578
 ** module chunks = 0
 **/